//MUI IMPORTS
import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Box, Button, Typography } from "@mui/material";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";

//MOMENT IMPORT
import moment from "moment";

//CUSTOM IMPORTS
import DialogIIBB_Formulario from "./DialogIIBB_Formulario";
import { UrlApi } from "../../../../../services/apirest";
import * as api from "./api"
import InscripcionesExclusionesContainer from "./components/ui/InscripcionesExclusionesContainer";
import { getData } from "../../../../../services/library";
import {fetchPermisos} from "../../../../../services/services"

function ImpuestosCliente(props) {
  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  const [percepcionIva, setPercepcionIva] = useState();
  const [showFormIIBB, setShowFormIIBB] = useState(false);
  const [editarPercIva, setEditarPercIva] = useState(false);
  const [iibb, setiibb] = useState([]);
  const configConvenio = JSON.parse(props?.cliente?.config_convenio) || {}
  const [ciclo, setCiclo]=useState();
  // const registraInscripciones = Number((JSON.parse(props?.cliente?.config_convenio)?.max_inscripciones) > 0) || false

  /* ---------------------------- HANDLERS ------------------------------------  */
  async function guardar(e) {
    e.preventDefault();
    setEditarPercIva(false);
    const response = await fetch(UrlApi + "/clientes/" + props.cliente.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(percepcionIva),
    });
    api.getPercepcionIva(props.cliente.id, setPercepcionIva);
  }

  const almacenarPercIva = (e) => {
    setPercepcionIva({ ...percepcionIva, [e.target.name]: e.target.value });
  };
  const [lastUpdate, setLastUpdate]=useState("");
  const [permisos, setPermisos]=useState();
  const [showUpdates, setShowUpdates] = useState();

  const getPermisos = async() =>{
    const allPermisos = await fetchPermisos();
    const permisosModulo = allPermisos.filter(permiso=>permiso.modulo === "clientes_impuestos");
    setPermisos(permisosModulo)
    setShowUpdates(!!permisosModulo?.find(permiso=>permiso.funcion == "ver_actualizaciones"))
  }

  const getDatosCiclo = (configConvenio, setCiclo) => {
    if (configConvenio?.inscripcion_vence == 1) {
      // console.log("Las inscripciones del ciclo vencen, o sea tiene CM");
      api.getCicloFiscalActual(setCiclo);
    } else {
      // console.log("Las inscripciones del ciclo NO VENCEN. Es convenio directo general.");
      setCiclo({
        id_ciclo: null,
      });
    }
  }

  /* ---------------------------- EFFECTS  ------------------------------------  */
  useEffect(() => {
    api.getPercepcionIva(props.cliente.id, setPercepcionIva);
    getData(
      `/iibb_clientes_logs/ultima_modificacion/${props.cliente.cuit}`,
      setLastUpdate
    );
    getPermisos();
    getDatosCiclo(configConvenio, setCiclo);
  }, []);

  useEffect(() => {
    if (permisos && ciclo) {
      if (!!showUpdates){
        api.getAllInscripciones(props.cliente.cuit, ciclo?.id_ciclo, setiibb)
      } else {
        getData("/iibb_clientes/alliibb-sinperiodo/" + props.cliente.cuit, setiibb);
      }
    }
  }, [permisos, ciclo]);

  useEffect(() => {
    getData(
      `/iibb_clientes_logs/ultima_modificacion/${props.cliente.cuit}`,
      setLastUpdate
    );
    if (permisos && ciclo) {
      if (!!showUpdates){
        api.getAllInscripciones(props.cliente.cuit, ciclo?.id_ciclo, setiibb)
      } else {
        getData("/iibb_clientes/alliibb-sinperiodo/" + props.cliente.cuit, setiibb);
      }
    }
  }, [showFormIIBB]);

  /* ---------------------------- STYLING  ------------------------------------  */

  const columns = useMemo(
    () => [
      {
        // VA A FORMATEAR LAS FECHAS DE INICIO DE VIGENCIA DE LAS PERCEPCIONES POR PADRON. NO ASI DE LAS INGRESADAS A MANO
        accessorKey: "fecha_vigencia_desde",
        header: "Fecha Inicio Vigencia",
        Cell: ({ cell }) => {
          const fecha = cell.getValue();
          return moment(fecha).format("DD-MM-YYYY");
        },
      },
      {
        // VA A FORMATEAR LAS FECHAS DE INICIO DE VIGENCIA DE LAS PERCEPCIONES POR PADRON. NO ASI DE LAS INGRESADAS A MANO a
        accessorKey: "fecha_vigencia_hasta",
        header: "Fecha Fin Vigencia",
        Cell: ({ cell }) => {
          const fecha = cell.getValue();
          return fecha
            ? moment(fecha).format("DD-MM-YYYY")
            : "Fecha Indefinida";
        },
      },
      {
        accessorKey: "provincia",
        header: "Provincia",
      },
      {
        accessorKey: "percepcion",
        header: "Percepción",
      },
      {
        accessorKey: "porcentaje_excencion",
        header: "Exencion",
      },
      {
        accessorKey: "vto_excencion",
        header: "Vencimiento Exención",
        Cell: ({ cell }) => {
          const vto_ex = cell.getValue();
          return vto_ex ? moment(vto_ex).format("DD-MM-YYYY") : "";
        },
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: 5,
      pageIndex: 0,
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const [showFormIIBB2, setShowFormIIBB2] = useState(false);

  /* ---------------------------- RENDER  ------------------------------------  */
  return (
    <div>
      <Box boxShadow={3} px={2} py={1} backgroundColor="#ebebeb">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6" sx={{ fontSize: 16 }} color="primary">
            Impuestos Nacionales (Percepción de Iva)
          </Typography>
          {editarPercIva ? (
            <Button
              variant="text"
              onClick={(e) => guardar(e)}
              disabled={
                (!!percepcionIva.porc_exc_perc_iva &&
                  !percepcionIva.vto_exc_perc_iva) ||
                (!percepcionIva.porc_exc_perc_iva &&
                  !!percepcionIva.vto_exc_perc_iva) ||
                (!!percepcionIva.porc_exc_perc_iva &&
                  percepcionIva.porc_exc_perc_iva > 100)
              }
            >
              Guardar
            </Button>
          ) : (
            <Button
              variant="text"
              onClick={() => setEditarPercIva(true)}
              disabled={props.soloLectura}
            >
              Editar
            </Button>
          )}
        </Grid>
        {percepcionIva && (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Grid item xs={3}>
              <Typography variant="subtitle2" color="initial">
                Percepción Iva
              </Typography>
            </Grid>
            <Grid item xs={4.5}>
              <TextField
                disabled={!editarPercIva}
                style={{ backgroundColor: "#fff" }}
                size="small"
                fullWidth
                focused
                label="% Exención"
                value={percepcionIva.porc_exc_perc_iva}
                name="porc_exc_perc_iva"
                onChange={almacenarPercIva}
                error={percepcionIva.porc_exc_perc_iva > 100}
                helperText={
                  percepcionIva.porc_exc_perc_iva > 100
                    ? "Porcentaje no puede ser mayor a 100"
                    : ""
                }
              />
            </Grid>
            <Grid item xs={4.5}>
              <TextField
                disabled={!editarPercIva}
                style={{ backgroundColor: "#fff" }}
                type="date"
                size="small"
                fullWidth
                focused
                label="Vto Exención"
                InputLabelProps={{ shrink: true }}
                value={percepcionIva.vto_exc_perc_iva}
                name="vto_exc_perc_iva"
                onChange={almacenarPercIva}
              />
            </Grid>
          </Grid>
        )}
      </Box>
      <br />
      <Box boxShadow={3} pt={1} backgroundColor="#ebebeb">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          px={2}
        >
          <Typography variant="h6" sx={{ fontSize: 16 }} color="primary">
            Impuestos Provinciales (Ingresos Brutos) - Inscripciones / CM05{" "}
          </Typography>
          { !showUpdates ? (
            <Button
              variant="text"
              onClick={() => setShowFormIIBB(true)}
              disabled={props.soloLectura}
            >
              Editar
            </Button>
          ) : (<Button
            variant="text"
            onClick={() => setShowFormIIBB2(true)}
            disabled={props.soloLectura}
          >
            Editar (C/ Ciclos)
          </Button>
          )}
        </Grid>
        <MaterialReactTable
          enableTopToolbar={false}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          localization={{
            ...MRT_Localization_ES,
            noRecordsToDisplay: !configConvenio ? "Es necesario registrar la sit. iibb del cliente.." : "No hay inscripciones registradas para este cliente.",
          }}
          columns={columns}
          data={iibb}
          enableColumnFilterModes={false}
          enableColumnOrdering={false}
          enableGrouping={false}
          enableEditing={false}
          initialState={initialState}
          positionActionsColumn="last"
          enableHiding={false}
          enableExpandAll={false}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableDensityToggle={false}
          renderBottomToolbarCustomActions={() =>
            lastUpdate ? (
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ padding: "8px" }}
              >
                Última actualización:{" "}
                {moment(lastUpdate.created_at).format("DD-MM-YYYY")} || Usuario:{" "}
                {lastUpdate.usuario}
              </Typography>
            ) : (
              <></>
            )
            // <Typography variant="caption" color="textSecondary" sx={{ padding: '8px' }}>
            // </Typography>
          }
        />
      </Box>
      <br />
      <br />
      {showFormIIBB && (
        <DialogIIBB_Formulario
          open={showFormIIBB}
          setOpen={setShowFormIIBB}
          cliente={props.cliente}
        />
      )}
      {showFormIIBB2 && (
        <InscripcionesExclusionesContainer
          open={showFormIIBB2}
          setOpen={setShowFormIIBB2}
          cliente={props.cliente}
          cicloFiscalActual={ciclo}
          showUpdates={showUpdates}
        />
      )}
    </div>
  );
}

export default ImpuestosCliente;
